export enum UserTypes {
    LOGIN = 'LOGIN',
}
